<script lang="ts">
  import { MousePointer2 } from '@lucide/svelte'
  import i18n from '../../../i18n'
  import { sceneMode } from '../../../stores/scene-mode'
  import Button from '../../button/Button.svelte'
  import Tooltip from '../../tooltip/Tooltip.svelte'
</script>

<Tooltip title={$i18n.t('project.island.default')}>
  <Button
    size="icon-sm"
    variant={$sceneMode === 'default' ? 'default' : 'ghost'}
    onclick={() => ($sceneMode = 'default')}
  >
    <MousePointer2 />
  </Button>
</Tooltip>
